import { useEffect } from "react";
import { JOTFORM_AGENT_ID } from "@/constants/links";

// Use the customer's own JotForm subdomain — bypasses parentURL/domain
// validation that returned "Agent not found" on the production host.
const EMBED_BASE = "https://integratedwellness.jotform.com/agent/embedjs";

/**
 * Floating JotForm AI Agent — injected once site-wide.
 * Renders nothing; the embed script attaches its own floating chat UI.
 */
export default function JotformAgent() {
  useEffect(() => {
    const SCRIPT_ID = "jotform-agent-script";
    if (document.getElementById(SCRIPT_ID)) return;

    const s = document.createElement("script");
    s.id = SCRIPT_ID;
    s.src = `${EMBED_BASE}/${JOTFORM_AGENT_ID}/embed.js?skipWelcome=1&maximizable=1`;
    s.async = true;
    document.body.appendChild(s);
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only injection
  }, []);

  return null;
}
